import io from 'socket.io-client';
import {parseUrl} from '../helpers';
import MAYA from '../maya_api';
import CONFIG from '../config';
import {ERROR_TYPES} from '../constants';
import _ from 'lodash';
import {appSetObj} from '../store/application';

let socket = null;

export function getSocket() {
  return socket;
}

function updateDeviceSocket() {
  if (MAYA.isAuthenticated()) {
    MAYA.updateDeviceSocket();
  }
}

export function connectSocket() {
  console.log('Socket.io connecting to', CONFIG.MAYA_API);
  const socketUrl = parseUrl(CONFIG.MAYA_API);

  socket = io.connect(socketUrl.origin, {
    path: socketUrl.pathname,
    transports: ['websocket'],
    timeout: 5000,
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0,
    autoConnect: true,
  });

  socket.on('/echo', function () {
    console.log('=> /echo');
  });

  socket.on('/device_error', async function (result) {
    console.log('=> /device_error');
    const {setError} = await import('../components/shared/ErrorOverlay/modules/error');
    const {getStore} = await import('../main');
    const store = getStore();
    const errorType = ERROR_TYPES[result.type] ? ERROR_TYPES[result.type] : '';
    if (!errorType) console.log('Error type not found', result.type);
    return store.dispatch(setError(errorType));
  });

  socket.on('/s/data', async function (result) {
    console.log('=> /s/data');
    const {getStore} = await import('../main');
    const store = getStore();
    const state = store.getState();
    const sessionGuid = _.get(state, 'app.session_guid');
    if (!sessionGuid) {
      return console.log('[/s/data] Session is not active');
    }
    const sessionData = result[sessionGuid];
    if (!sessionData) {
      return console.log('[/s/data] Data by session_guid not found', result, sessionGuid);
    }
    const allowedProperties = {
      image_file_path: '',
      image_path: '',
      image_path_original: '',
      check_insert: '',
      check_removed: '',
      check_scan_front: '',
      image_path_front: '',
      image_file_path_front: '',
      check_scan_back: '',
      image_path_back: '',
      image_file_path_back: '',
    };
    const sessionModifierObject = _.pick(sessionData, _.keys(allowedProperties));
    console.log('[/s/data] Updates from server session => ', sessionModifierObject);
    store.dispatch(appSetObj(sessionModifierObject));
  });

  socket.on('/cart/status', async function (result) {
    console.log('=> /cart/status');
    const {PAYMENT_STATUS} = await import('../constants');
    const payment_id = result.payment_id;
    if (!payment_id) return console.error('[PAYMENT STATUS] Payment id not found', result);
    const statusCode = result.status_code && PAYMENT_STATUS[result.status_code];
    if (!statusCode) return console.error('[PAYMENT STATUS] Status not defined', result.status_code);
    console.log('[Payment status]', result.status_code, payment_id);
    const {updatePaymentStatus} = await import('../components/ShoppingCart/modules/shoppingCart');
    const {getStore} = await import('../main');
    const store = getStore();
    store.dispatch(updatePaymentStatus(payment_id, statusCode, _.extend({}, result.data)));
  });

  socket.on('/cart/receipt', async function (result) {
    console.log('=> /cart/receipt');
    const {RECEIPT_STATUS} = await import('../constants');
    const statusCode = result.status_code && RECEIPT_STATUS[result.status_code];
    if (!statusCode) return console.error('[Receipt] Status not defined', result.status_code);
    console.log('[Receipt status]', result.status_code);
    const {updateCommonReceipt} = await import('../components/ShoppingCart/modules/shoppingCart');
    const {getStore} = await import('../main');
    const store = getStore();
    store.dispatch(updateCommonReceipt(statusCode, result.receipt_url));
  });

  socket.on('/report/success', async function () {
    console.log('=> /report/success');
    const {loadReports, setGenerationLoading, resetFilterDates} = await import('../components/Reports/modules/reports');
    const {getStore} = await import('../main');
    const store = getStore();
    store.dispatch(setGenerationLoading(false));
    store.dispatch(resetFilterDates());
    store.dispatch(loadReports());
  });

  socket.on('/bill/image', async function (data) {
    console.log('=> /bill/image');
    const {appSetVal, appSetObj} = await import('../store/application');
    const {getStore} = await import('../main');
    const store = getStore();
    store.dispatch(appSetVal('bill_image_processing', false));
    if (!(data && data.account)) {
      store.dispatch(appSetVal('scanner_account_error', true));
    }
    store.dispatch(appSetObj({
      account: data.account,
      account1: data.account,
    }));
  });

  socket.on('/bill/image/error', async function () {
    console.log('=> /bill/image/error');
    const {appSetVal} = await import('../store/application');
    const {getStore} = await import('../main');
    const store = getStore();
    store.dispatch(appSetVal('bill_image_processing', false));
    store.dispatch(appSetVal('scanner_account_error', true));
  });

  socket.on('connect_failed', function () {
    console.error('[Socket.io] Connect_failed');
  });

  socket.on('connect', function () {
    console.log(`[Socket.io] Connected to ${CONFIG.MAYA_API}`);
    updateDeviceSocket();
  });

  socket.on('disconnect', function () {
    console.log(`[Socket.io] Disconnected from ${CONFIG.MAYA_API}`);
  });

  socket.on('close', function () {
    console.log(`[Socket.io] Closed connection to ${CONFIG.MAYA_API}`);
  });

  socket.on('reconnect', function () {
    console.log(`[Socket.io] Attempting to reconnect to ${CONFIG.MAYA_API}`);
    updateDeviceSocket();
  });
}

connectSocket();





// WEBPACK FOOTER //
// ./src/sockets/index.js